import React, { useState } from "react";
import LiveOrdersNavbar from "../components/navbars/LiveOrdersNavbar";
import { Outlet } from "react-router-dom";

export default function LiveOrdersLayout() {

    return (
        <section className="live-order-layout-section">

            <LiveOrdersNavbar />
            <section className="live-order-main-section"
                style={{ height: "100vh", overflow: "auto", backgroundColor: "#f5f5f5" }}
            >
                <Outlet />
            </section>

        </section>
    );
}